import { render, staticRenderFns } from "./PlaylistPersonalItem.vue?vue&type=template&id=83117772&scoped=true"
import script from "./PlaylistPersonalItem.vue?vue&type=script&lang=js"
export * from "./PlaylistPersonalItem.vue?vue&type=script&lang=js"
import style0 from "./PlaylistPersonalItem.vue?vue&type=style&index=0&id=83117772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83117772",
  null
  
)

export default component.exports